module.exports = __webpack_public_path__ + "static/media/4ODA6.c92ea7dc.jpg";